import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useApp } from "../store";

export default function LegalPage() {
  const { c, t } = useApp();

  return (
    <div className="min-h-screen text-white grain relative theme-public" style={{ background: "var(--sec-legal-bg, #0A1428)" }} data-testid="legal-page">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-20 sm:py-28 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <h1 data-testid="legal-title" className="font-display font-semibold text-3xl sm:text-4xl tracking-tight">
            {c("legal_title")}
          </h1>
          <div className="w-16 h-px bg-[var(--accent)] my-8" />
          <p data-testid="legal-text" className="whitespace-pre-wrap text-sm sm:text-base text-white/70 leading-relaxed">
            {c("legal_text")}
          </p>
          <Link
            data-testid="legal-back-link"
            to="/"
            className="mt-14 inline-flex items-center gap-2 font-mono2 text-[11px] uppercase tracking-[0.25em] text-white/40 hover:text-[var(--accent-soft)] transition-colors duration-300"
          >
            <ArrowLeft size={13} />
            {t("login_back")}
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
